import React from 'react';

export default function PipelineStatus({ attestation, plant }) {
    const status = attestation?.status || plant?.status || 'pending';
    const accumulator = parseFloat(plant?.accumulator_kwh) || 0;
    const gccStatus = plant?.gcc_registration_status || 'not_started';
    const serial = attestation?.evidentSerial || plant?.evident_serial_prefix || '';

    // Step 1: Sensor Data Ingested
    const step1Active = accumulator > 0 || attestation || status === 'active' || status === 'retired';
    
    // Step 2: Committee Verification
    const step2Active = status === 'active' || status === 'retired';
    
    // Step 3: GCC/Evident Registration
    const step3Progress = gccStatus === 'submitted' || gccStatus === 'documents_preparing';
    const step3Active = gccStatus === 'approved' || serial !== '';
    
    // Step 4: I-REC Issuance
    const step4Active = serial !== '';
    
    // Step 5: Available / Retired
    const step5Active = status === 'retired';

    const steps = [
        { label: 'Sensor Data', active: step1Active, progress: false, desc: 'Telemetry active' },
        { label: 'Committee Sign-off', active: step2Active, progress: false, desc: 'Verifier signature' },
        { label: 'GCC Registration', active: step3Active, progress: step3Progress && !step3Active, desc: gccStatus.replace('_', ' ') },
        { label: 'I-REC Issuance', active: step4Active, progress: false, desc: serial ? 'Serial assigned' : 'Pending serial' },
        { label: 'Retired / Market', active: step5Active, progress: false, desc: status === 'retired' ? 'Retired' : 'Available' }
    ];

    return (
        <div className="w-full py-4 px-2">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-2">
                {steps.map((step, idx) => (
                    <React.Fragment key={idx}>
                        {/* Step Card */}
                        <div className="flex-1 flex items-center gap-3 w-full md:w-auto bg-white/5 border border-white/10 rounded-2xl p-3">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs ${
                                step.active 
                                    ? 'bg-emerald-500 text-white' 
                                    : step.progress 
                                        ? 'bg-yellow-500 text-black animate-pulse' 
                                        : 'bg-white/10 text-slate-500'
                            }`}>
                                {step.active ? '✓' : idx + 1}
                            </div>
                            <div className="text-left">
                                <p className="text-xs font-bold text-slate-200">{step.label}</p>
                                <p className={`text-[10px] capitalize ${step.active ? 'text-emerald-400 font-semibold' : step.progress ? 'text-yellow-400' : 'text-slate-500'}`}>{step.desc}</p>
                            </div>
                        </div>
                        
                        {/* Connector Line */}
                        {idx < steps.length - 1 && (
                            <div className={`hidden md:block w-4 h-0.5 ${step.active ? 'bg-emerald-500/50' : 'bg-white/10'}`}></div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}
